if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-product-tab-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-product-tab-panel]'));

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.selectTab(button));
          button.addEventListener('keydown', (event) => this.onKeyDown(event));
        });
      }

      onKeyDown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();

        const currentIndex = this.buttons.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = currentIndex - 1;
        if (event.key === 'ArrowRight') nextIndex = currentIndex + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.buttons.length - 1;

        if (nextIndex < 0) nextIndex = this.buttons.length - 1;
        if (nextIndex >= this.buttons.length) nextIndex = 0;

        this.selectTab(this.buttons[nextIndex]);
        this.buttons[nextIndex].focus();
      }

      selectTab(activeButton) {
        const activePanelId = activeButton.getAttribute('aria-controls');

        this.buttons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== activePanelId;
        });
      }
    }
  );
}
